import { Platform } from "react-native";

import { CLUB_SLUG_STORAGE_KEY } from "@whoosh/relay/src/constants";
import {
  deleteExpoSecureStoreItemAsync,
  setExpoSecureStoreItemAsync,
} from "@whoosh/utilities/src/ExpoSecureStore/expoSecureStore";

export const setResetPasswordClubContext = async (
  clubSlug?: string
): Promise<void> => {
  // TODO(ENG-2770): Require club context after reset and registration links created by legacy backends have expired.
  if (!clubSlug) {
    if (Platform.OS === "web") {
      localStorage.removeItem(CLUB_SLUG_STORAGE_KEY);
    } else {
      await deleteExpoSecureStoreItemAsync(CLUB_SLUG_STORAGE_KEY);
    }

    return;
  }

  if (Platform.OS === "web") {
    localStorage.setItem(CLUB_SLUG_STORAGE_KEY, clubSlug);
  } else {
    await setExpoSecureStoreItemAsync(CLUB_SLUG_STORAGE_KEY, clubSlug);
  }
};
